// intentionally redundant to reduce core dependencies

export const KMN_VERIFICATION_STATUS_TYPE = {
    APPROVED: 'APPROVED',
};

export const POST_20240130_SENDABLE_TOLL_FREE_SMS_STATUSES = [
    KMN_VERIFICATION_STATUS_TYPE.APPROVED,
];
